import { IFund } from '@aletheia/eafunds/contentful/types/generated'

export type TMarkdownField = {
  id: keyof Pick<
    IFund['fields'],
    'objects' | 'about' | 'grantmakingAndImpact' | 'pros' | 'cons'
  >
  name: string
}

export function getMarkdownFields(Fund: IFund['fields']): TMarkdownField[] {
  return ([
    {
      id: 'objects',
      name: 'Fund Scope',
    },
    {
      id: 'about',
      name: `About the ${Fund.title} Fund`,
    },
    {
      id: 'grantmakingAndImpact',
      name: 'Grantmaking and Impact',
    },
    {
      id: 'pros',
      name: 'Why donate to this Fund?',
    },
    {
      id: 'cons',
      name: 'Why you might choose not to donate to this Fund',
    },
  ] as TMarkdownField[]).filter((a) => Fund[a.id])
}
